<template>
  <div>
    <!-- 顶部欢迎及注册登录按钮导航 -->
    <header-top />
    <!-- 顶部公司logo及导航栏 -->
    <div style="width:100%;height:100px;">
      <div class="logoNav">
        <!-- 左侧logo -->
        <span style="font-size: 26px;font-weight: bold;color: #0848cd;margin-top: 40px;display: inline-block;">医疗器械领域数据库</span>
<!--        <img src="../../assets/img/weigaoLogo.png" width="200" style="margin-top:30px;">-->

        <!-- 右侧小图标 -->
        <img src="../../assets/img/home/head-bg.png" style="position: absolute;right: 0;bottom: 0;" width="450">
        <!-- <img src="../../assets/img/home/homelogoHeadRight.png"> -->
      </div>
    </div>
    <!-- 导航栏 -->
    <nav-head></nav-head>
    <!--查询专利分页内容-->
    <div class="zlQueryList">
      <div class="queryInput">
        <el-input v-model="queryString" style="width: 50%;"></el-input> <el-button type="primary" @click="toQuery()" plain>查询</el-button>
        <span style="margin-left: 10px; color: #488ef6;">每页显示</span>
        <el-select v-model="paginationData.everySize" placeholder="请选择" style="width: 5%;">
          <el-option label="10" value="10"></el-option>
          <el-option label="20" value="20"></el-option>
          <el-option label="30" value="30"></el-option>
          <el-option label="50" value="50"></el-option>
          <el-option label="100" value="100"></el-option>
        </el-select>
        <span style="color: #488ef6">条</span>
        <span style="margin-left: 10px;color: #488ef6;">共 {{paginationData.allNum}} 条</span>
        <el-select v-model="queryFrom.sort" placeholder="排序方式" style="width: 350px; margin-left: 10px" @change="toQuery()">
          <el-option v-for="item in sortList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="zlQueryListContent"  v-for="(item, index) in zlData" style="margin-bottom: 5px">
        <el-row :gutter="20">
          <el-col :span="4">
            <div class="ThumbDiv">
              <el-image :src="item.thumbnail === null ? wutu : item.thumbnail" style="width: 170px;height: 170px; "></el-image>
            </div>
          </el-col>
          <el-col :span="19">
            <el-row>
              <h3 class="zlName" @click="goZlDetail(item.id)">{{item.name}}-{{item.applicationNumber}};{{item.openNumber}}</h3>
              <el-tag v-if="item.legalStatus !== null && item.legalStatus.length > 1" v-for="data in item.legalStatus.split(',')" style="margin-left: 10px" type="success">{{ data }}</el-tag>
            </el-row>
            <el-row>
              <h4 class="zlName2">{{item.foreignName}}</h4>
            </el-row>
            <el-row>
              <h4 class="zlName2" style="color: #1e7e34">申请人：{{item.applicant}} - 申请日：{{item.applicantDate}} - 公开日：{{item.openDate}} - 分类号：{{item.ipcMainClassify}}</h4>
            </el-row>
            <!--摘要-->
            <el-row>
              <span class="zy">{{item.absrtact}}</span>
            </el-row>
            <el-row style="margin-top: 5px;">
              <el-image v-show="item.isCollect === 0" :src="wsc" style="width: 30px; height: 30px" @click="addOpenCollection(item.id,item.type)"></el-image>
<!--              <el-image v-show="item.isCollect !== 0" :src="ysc" style="width: 30px; height: 30px"></el-image>-->
              <el-popconfirm title="确定要取消收藏吗？" @confirm="cancelUserCollectionPatent(item.collectionId,item.id)">?">
                <template #reference>
                  <el-image v-show="item.isCollect !== 0" :src="ysc" style="width: 30px; height: 30px"></el-image>
                </template>
              </el-popconfirm>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <!--分页-->
      <div style="background-color: #ffffff;width: 95%; margin: 0px auto">
        <el-pagination
            @current-change="handleCurrentChange"
            :current-page="paginationData.currPage"
            :page-sizes="[10, 20, 30, 50, 100, 200]"
            :page-size="paginationData.everySize"
            layout="total, prev, pager, next"
            :total="paginationData.allNum">
        </el-pagination>
      </div>

    <!--添加到收藏夹的弹窗-->
      <el-dialog title="添加到收藏夹" v-model="addDialogVisible"  width="30%" >
        <el-row style="border: rgba(216,217,220,0.92) solid 0.5px;" v-for="(item, index) in collectionList">
          <el-col :span="12" style="align-content: center; text-align: center">
            <span style="font-size: 16px;">{{item.collectionName}}</span>
          </el-col>
          <el-col :span="12" style="">
            <el-button type="primary" style="float: right" @click="addToCollection(item.id)" plain>加入</el-button>
          </el-col>
        </el-row>
        <template #footer>
          <div class="dialog-footer">
            <el-button type="primary" @click="createDialogVisible=true" plain>创建收藏夹</el-button>
          </div>
        </template>
      </el-dialog>

      <el-dialog title="创建收藏夹" v-model="createDialogVisible"  width="30%" >
        <el-row style="border: rgba(216,217,220,0.92) solid 0.5px;">
          <el-col :span="10" style="align-content: center; text-align: center">
            <el-input v-model="createCollectionFrom.collectionName"  placeholder="请输入收藏夹名称"></el-input>
          </el-col>
          <el-col :span="6">
            <el-switch
                v-model="createCollectionFrom.isOpen"
                active-text="公开"
                inactive-text="私密">

            </el-switch>
          </el-col>
          <el-col :span="8" style="">
            <el-button type="primary" style="float: right" @click="createCollection" plain>创建</el-button>
          </el-col>
        </el-row>
      </el-dialog>

    </div>
  </div>

</template>
<script>
import wsc from "@/assets/img/zlicons/wsc.png"
import ysc from "@/assets/img/zlicons/ysc.png"
import wutu from "@/assets/img/wutu.png"
import NavHead from "@/components/navHead/navHead.vue";
import HeaderTop from "@/components/headerTop/headerTop.vue";

export default {
  name: "zlQueryList",
  components: {HeaderTop, NavHead},
  data() {
    return {
      wsc,
      ysc,
      wutu,
      collectionList: [],
      addDialogVisible: false,
      createDialogVisible: false,
      // 创建收藏夹
      createCollectionFrom: {
        userId: null,
        collectionName: '',
        isOpen: 1,
        type: null,
      },
      //加入收藏夹
      addCollectionFrom: {
        userId: null,
        collectionId: null,
        patentId: null,
        patentName: '',
        type: null,
      },
      queryJson: '',
      queryFrom: {
        // 综合搜索
        integrated_type: null,
        integrated_keyword: null,
        // 内容
        content_type_1: null,
        content_keyword_1: null,
        content_type_2: null,
        content_keyword_2: null,
        content_type_3: null,
        content_keyword_3: null,
        // 单位/人
        unit_or_person_1: null,
        unit_or_person_keyword_1: null,
        unit_or_person_2: null,
        unit_or_person_keyword_2: null,
        // 号码
        number_query_type_1: null,
        number_query_keyword_1: null,
        number_query_type_2: null,
        number_query_keyword_2: null,
        // 日期
        date_query_type_1: null,
        date_query_keyword_1: null,
        date_query_type_2: null,
        date_query_keyword_2: null,
        // 分类
        classification_type: null,
        classification_keyword: null,
        // 代理所/人
        agent_type: null,
        agent_keyword: null,
        // 同族/引用
        same_family_type: null,
        same_family_keyword: null,
        same_family2_type: null,
        same_family2_keyword: null,
        // 优先权/PCT
        pct_type_1: null,
        pct_keyword_1: null,
        pct_type_2: null,
        pct_keyword_2: null,
        // 法律状态
        legal_status_type: null,
        legal_status_keyword: null,
        //排序
        sort: 'no',
      },
      zlData: null,
      paginationData: {
        currPage: 1,
        everySize: 30,
        allNum: 0
      },
      queryString: '',
      sortList:[
          {
            label: '无排序',
            value: 'no'
          },
          {
            label: '申请日降序',
            value: 'applicantDateDesc'
          },
          {
            label: '申请日升序',
            value: 'applicantDateAsc'
          },
          {
            label: '公开日降序',
            value: 'openDateDesc'
          },
          {
            label: '公开日升序',
            value: 'openDateAsc'
          }

      ]
    }
  },
  mounted() {
    this.queryFrom = JSON.parse(this.$route.params.queryFrom)
    this.queryJson = JSON.stringify(this.remove_empty(this.queryFrom))
    this.queryFrom.currPage = this.paginationData.currPage
    this.queryFrom.everySize = this.paginationData.everySize
    this.getZlList()
    this.toQueryStr()
  },
  methods: {
    handleSizeChange(val) {
      this.paginationData.everySize = val
      this.queryFrom.currPage = this.paginationData.currPage*this.paginationData.everySize
      this.queryFrom.everySize = this.paginationData.everySize
      this.getZlList()
    },
    toQueryStr() {
      var integratedStr = ''
      if (this.queryFrom.integrated_type !== null && this.queryFrom.integrated_keyword !== null && this.queryFrom.integrated_keyword !== undefined) {
        integratedStr = this.queryFrom.integrated_keyword
      }

      var contentStr = ''
      if (this.queryFrom.content_type_1 !== null && this.queryFrom.content_keyword_1 !== null &&  this.queryFrom.content_keyword_1 !== undefined) {
        if (integratedStr !== '') {
          this.queryString += " AND "
        }
        contentStr += this.queryFrom.content_type_1 + ":" + this.queryFrom.content_keyword_1
      }
      if (this.queryFrom.content_type_2 !== null && this.queryFrom.content_keyword_2 !== null && this.queryFrom.content_keyword_2 !== undefined) {
        if (contentStr !== '') {
          contentStr += "  AND "
        }
        contentStr += this.queryFrom.content_type_2 + ":" + this.queryFrom.content_keyword_2
      }
      if (this.queryFrom.content_type_3 !== null && this.queryFrom.content_keyword_3 !== null && this.queryFrom.content_keyword_3 !== undefined) {
        if (contentStr !== '') {
          contentStr += "  AND "
        }
        contentStr += this.queryFrom.content_type_3 + ":" + this.queryFrom.content_keyword_3
      }
      var unitOrPersonStr = ''
      if (this.queryFrom.unit_or_person_1 != null && this.queryFrom.unit_or_person_keyword_1 !== null && this.queryFrom.unit_or_person_keyword_1 !== undefined) {
        unitOrPersonStr += this.queryFrom.unit_or_person_1 + ":" + this.queryFrom.unit_or_person_keyword_1
      }
      if (this.queryFrom.unit_or_person_2 != null && this.queryFrom.unit_or_person_keyword_2 !== null && this.queryFrom.unit_or_person_keyword_2 !== undefined) {
        if (unitOrPersonStr !== '') {
          unitOrPersonStr += "  AND "
        }
        unitOrPersonStr += this.queryFrom.unit_or_person_2 + ":" + this.queryFrom.unit_or_person_keyword_2
      }

      var numberStr = ''
      if (this.queryFrom.number_query_type_1 !== null && this.queryFrom.number_query_keyword_1 !== null && this.queryFrom.number_query_keyword_1 !== undefined) {
        numberStr += this.queryFrom.number_query_type_1 + ":" + this.queryFrom.number_query_keyword_1
      }
      if (this.queryFrom.number_query_type_2 != null && this.queryFrom.number_query_keyword_2 !== null && this.queryFrom.number_query_keyword_2 !== undefined) {
        if (numberStr !== '') {
          numberStr += "  AND "
        }
        numberStr += this.queryFrom.number_query_type_2 + ":" + this.queryFrom.number_query_keyword_2
      }

      var dateStr = ''
      if (this.queryFrom.date_query_type_1 !== null && this.queryFrom.date_query_keyword_1 !== null && this.queryFrom.date_query_keyword_1 !== undefined) {
        dateStr += this.queryFrom.date_query_type_1 + ":" + this.queryFrom.date_query_keyword_1
      }
      if (this.queryFrom.date_query_type_2 !== null && this.queryFrom.date_query_keyword_2 !== null && this.queryFrom.date_query_keyword_2 !== undefined) {
        if (dateStr !== '') {
          dateStr += "  AND "
        }
        dateStr += this.queryFrom.date_query_type_2 + ":" + this.queryFrom.date_query_keyword_2
      }

      var classificationStr = ''
      if (this.queryFrom.classification_type !== null && this.queryFrom.classification_keyword !== null && this.queryFrom.classification_keyword !== undefined) {
        classificationStr += this.queryFrom.classification_type + ":" + this.queryFrom.classification_keyword
      }
      var agentStr = ''
      if (this.queryFrom.agent_type !== null && this.queryFrom.agent_keyword !== null && this.queryFrom.agent_keyword !== undefined) {
        agentStr += this.queryFrom.agent_type + ":" + this.queryFrom.agent_keyword
      }
      var sameFamilyStr = ''
      if (this.queryFrom.same_family_type !== null && this.queryFrom.same_family_keyword !== null && this.queryFrom.same_family_keyword !== undefined) {
        sameFamilyStr += this.queryFrom.same_family_type + ":" + this.queryFrom.same_family_keyword
      }
      if (this.queryFrom.same_family2_type !== null && this.queryFrom.same_family2_keyword !== null && this.queryFrom.same_family2_keyword !== undefined) {
        if (sameFamilyStr !== '') {
          sameFamilyStr += "  AND "
        }
        sameFamilyStr += this.queryFrom.same_family2_type + ":" + this.queryFrom.same_family2_keyword
      }

      var pctStr = ''
      if (this.queryFrom.pct_type_1 !== null && this.queryFrom.pct_keyword_1 !== null && this.queryFrom.pct_keyword_1 !== undefined) {
        pctStr += this.queryFrom.pct_type_1 + ":" + this.queryFrom.pct_keyword_1
      }
      if (this.queryFrom.pct_type_2 !== null && this.queryFrom.pct_keyword_2 !== null && this.queryFrom.pct_keyword_2 !== undefined) {
        if (pctStr !== '') {
          pctStr += "  AND "
        }
        pctStr += this.queryFrom.pct_type_2 + ":" + this.queryFrom.pct_keyword_2
      }
      var legalStatusStr = ''
      if (this.queryFrom.legal_status_type !== null && this.queryFrom.legal_status_keyword !== null && this.queryFrom.legal_status_keyword !== undefined) {
        legalStatusStr += this.queryFrom.legal_status_type + ":" + this.queryFrom.legal_status_keyword
      }
      if (integratedStr !== '') {
        this.queryString = integratedStr
       }
      if (contentStr !== '') {
        if (this.queryString !== '') {
          this.queryString += " AND " + contentStr
        }else {
          this.queryString = contentStr
        }
      }
      if (unitOrPersonStr !== '') {
        if (this.queryString !== '') {
          this.queryString += " AND " + unitOrPersonStr
        }else {
          this.queryString = unitOrPersonStr
        }
      }
      if (numberStr !== '') {
        if (this.queryString !== '') {
          this.queryString += " AND " + numberStr
        }else {
          this.queryString = numberStr
        }
      }
      if (dateStr !== '') {
        if (this.queryString !== '') {
          this.queryString += " AND " + dateStr
        }else {
          this.queryString = dateStr
        }
      }
      if (classificationStr !== '') {
        if (this.queryString !== '') {
          this.queryString += " AND " + classificationStr
        }else {
          this.queryString = classificationStr
        }
      }
      if (agentStr !== '') {
        if (this.queryString !== '') {
          this.queryString += " AND " + agentStr
        }else {
          this.queryString = agentStr
        }
      }
      if (sameFamilyStr !== '') {
        if (this.queryString !== '') {
          this.queryString += " AND " + sameFamilyStr
        }else {
          this.queryString = sameFamilyStr
        }
      }
      if (pctStr !== '') {
        if (this.queryString !== '') {
          this.queryString += " AND " + pctStr
        }else {
          this.queryString = pctStr
        }
      }
      if (legalStatusStr !== '') {
        if (this.queryString !== '') {
          this.queryString += " AND " + legalStatusStr
        }else {
          this.queryString = legalStatusStr
        }
      }

    },
    queryStrToFrom() {
      // 去除字符串中的空格
      var andStr = this.queryString.replace(/^\s*|\s*$/g,"")
      andStr = andStr.split(/ (AND|OR) /)
      if (andStr.length > 1) {
        for (let i = 0; i < andStr.length; i++) {
          if (andStr[i].indexOf(':') !== -1) {
            var str = andStr[i].split(':')
            console.log(str)
            if (str.length === 1) {
              this.queryFrom.integrated_type = 'integratedQuery'
              this.queryFrom.integrated_keyword = str.replace(/^\s*|\s*$/g,"")
            }
            if (str.length === 2) {
              if (str[0] === this.queryFrom.content_type_1) {
                this.queryFrom.content_keyword_1 = str[1].replace(/^\s*|\s*$/g,"")
              }
              if (str[0] === this.queryFrom.content_type_2) {
                this.queryFrom.content_keyword_2 = str[1].replace(/^\s*|\s*$/g,"")
              }
              if (str[0] === this.queryFrom.content_type_3) {
                this.queryFrom.content_keyword_3 = str[1].replace(/^\s*|\s*$/g,"")
              }
              if (str[0] === this.queryFrom.unit_or_person_1) {
                this.queryFrom.unit_or_person_keyword_1 = str[1].replace(/^\s*|\s*$/g,"")
              }
              if (str[0] === this.queryFrom.unit_or_person_2) {
                this.queryFrom.unit_or_person_keyword_2 = str[1].replace(/^\s*|\s*$/g,"")
              }
              if (str[0] === this.queryFrom.number_query_type_1) {
                this.queryFrom.number_query_keyword_1 = str[1].replace(/^\s*|\s*$/g,"")
              }
              if (str[0] === this.queryFrom.number_query_type_2) {
                this.queryFrom.number_query_keyword_2 = str[1].replace(/^\s*|\s*$/g,"")
              }
              if (str[0] === this.queryFrom.date_query_type_1) {
                this.queryFrom.date_query_keyword_1 = str[1].replace(/^\s*|\s*$/g,"")
              }
              if (str[0] === this.queryFrom.date_query_type_2) {
                this.queryFrom.date_query_keyword_2 = str[1].replace(/^\s*|\s*$/g,"")
              }
              if (str[0] === this.queryFrom.classification_type) {
                this.queryFrom.classification_keyword = str[1].replace(/^\s*|\s*$/g,"")
              }
              if (str[0] === this.queryFrom.agent_type) {
                this.queryFrom.agent_keyword = str[1].replace(/^\s*|\s*$/g,"")
              }
              if (str[0] === this.queryFrom.same_family_type) {
                this.queryFrom.same_family_keyword = str[1].replace(/^\s*|\s*$/g,"")
              }
              if (str[0] === this.queryFrom.same_family2_type) {
                this.queryFrom.same_family2_keyword = str[1].replace(/^\s*|\s*$/g,"")
              }
              if (str[0] === this.queryFrom.pct_type_1) {
                this.queryFrom.pct_keyword_1 = str[1].replace(/^\s*|\s*$/g,"")
              }
              if (str[0] === this.queryFrom.pct_type_2) {
                this.queryFrom.pct_keyword_2 = str[1].replace(/^\s*|\s*$/g,"")
              }
              if (str[0] === this.queryFrom.legal_status_type) {
                this.queryFrom.legal_status_keyword = str[1].replace(/^\s*|\s*$/g,"")
              }
            }
          }
        }
      }
    },
    addOpenCollection(collectionId, type) {
      this.addDialogVisible = true;
      this.addCollectionFrom.patentId = collectionId
      if (type === '专利') {
        this.addCollectionFrom.type = 1
        this.createCollectionFrom.type = 1
      }else {
        this.addCollectionFrom.type = 2
        this.createCollectionFrom.type = 2
      }
      this.getCollectionList(this.addCollectionFrom.type)
    },
    toQuery() {
      this.queryStrToFrom()
      //等待3秒
      // setTimeout(() => {
      //   this.queryFrom.currPage = this.paginationData.currPage
      //   this.queryFrom.everySize = this.paginationData.everySize
      //   this.getZlList()
      // }, 3000)
      this.queryFrom.currPage = this.paginationData.currPage
      this.queryFrom.everySize = this.paginationData.everySize
      this.getZlList()
    },
    remove_empty(obj) {
      for (const key in obj) {
        if (obj[key] === null || obj[key] === undefined || obj[key] === 'null') {
          delete obj[key];
        } else if (typeof obj[key] === 'object' && Object.keys(obj[key]).length === 0) {
          delete obj[key];
        }
      }
      return obj;
    },
    handleCurrentChange(val) {
      if (val) {
        this.paginationData.currPage = val
      } else {
        this.paginationData.currPage = 1
      }
      this.queryFrom.currPage = this.paginationData.currPage
      this.queryFrom.everySize = this.paginationData.everySize
      this.getZlList()
    },
    nextClick() {
      this.queryFrom.currPage = this.paginationData.currPage*this.paginationData.everySize
      this.queryFrom.everySize = this.paginationData.everySize
      this.getZlList()
    },
    prevClick() {
      this.queryFrom.currPage = this.paginationData.currPage*this.paginationData.everySize
      this.queryFrom.everySize = this.paginationData.everySize
      this.getZlList()
    },
    //取消收藏
    cancelUserCollectionPatent(collectionId, patentId) {
      this.axios.get('/api/userCollectionPatent/cancelUserCollectionPatent?collectionId='+collectionId+'&patentId='+patentId).then(res => {
        if (res.data.code === 10001) {
          this.$message({
            message: '取消收藏成功',
            type: 'success'
          })
          this.getZlList()
        } else {
          this.$message({
            message: '取消收藏失败',
            type:'error'
          })
        }
      })
    },
    goZlDetail(id) {
      var from = {id: id}
      this.$router.push({
        name: 'zlDetail',
        params: {
          queryId: JSON.stringify(from)
        }
      })
    },
    /* 添加到收藏夹 */
    addToCollection(id) {
      this.addCollectionFrom.collectionId = id
      this.axios.post('/api/userCollectionPatent/insertUserCollectionPatent', this.addCollectionFrom).then(res => {
        if (res.data.code === 10001) {
          this.addDialogVisible = false
          this.$message({
            message: '添加成功',
            type: 'success'
          })
          this.getZlList()
        } else {
          this.$message({
            message: '添加失败',
            type: 'error'
         })
        }
      })
    },
    /* 创建收藏夹 */
    createCollection() {
      this.axios.post('/api/userCollection/insertUserCollection', this.createCollectionFrom).then(res => {
        if (res.data.code === 10001) {
          this.getCollectionList(this.addCollectionFrom.type)
          this.createDialogVisible = false
          this.$message({
            message: '创建成功',
            type: 'success'
          })
        } else {
          this.$message({
            message: '创建失败',
            type: 'error'
         })
        }
      })
    },
    /* 获取收藏夹列表 */
    getCollectionList(type) {
      this.axios.get('/api/userCollection/findAllUserCollectList?type='+type).then(res => {
        this.collectionList = res.data
      })
    },
    /* 获取专利列表 */
    getZlList() {
      this.axios.get('/api/patentJournals/findZLByCondition', {params: this.queryFrom}).then(res => {
        this.zlData = res.data.data.patents
        this.paginationData = res.data.data.pagingBean
      })
    }
  }
}
</script>
<style scoped>
/* logo及导航栏 */
.logoNav {
  width: 1200px;
  height: 100px;
  margin: 0 auto;
  position: relative;
  bottom: 8px;
}

.zlQueryList {
  background-color: rgba(216, 217, 220, 0.92);
  margin: 0px auto;
  width: 100%;
  height: 100%;
  padding-top: 5px;
}

.zlQueryListContent {
  width: 95%;
  background-color: #fff;
  margin: 0px auto;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 50px;
}
.queryInput {
  width: 95%;
  margin: 0px auto;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 50px;
}
.ThumbDiv {
  border: 1px solid rgb(187,187,187);
  text-align: center;
}
.zlName {
  font-size: 16px;
  font-weight: normal;
  color: #00c;
  text-decoration: underline;
}
.zlName:hover {
  cursor: pointer;
}
.zlName2 {
  font-size: 12px;
  font-weight: normal;
  color: #00c;
}
.zy {
  font-size: 14px;
  font-weight: normal;
  color: #000000;
}
</style>
